export default "__VITE_ASSET__xsLVYLV___"